import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sxProps?: SxProps
  [prop: string]: any
}
export const LocationIcon = ({ sxProps, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ color: 'gray', width: '24px', height: '24px', ...sxProps }}
    {...props}
  >
    <path d="M12 4c2.2 0 4 1.8 4 4 0 2.1-2.1 5.5-4 7.9-1.9-2.5-4-5.8-4-7.9 0-2.2 1.8-4 4-4Zm0-2C8.7 2 6 4.7 6 8c0 4.5 6 11 6 11s6-6.6 6-11c0-3.3-2.7-6-6-6Zm0 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm8 13c0 2.2-3.6 4-8 4s-8-1.8-8-4c0-1.3 1.2-2.4 3.1-3.2l.6.9c-1 .5-1.7 1.1-1.7 1.8 0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5c0-.7-.7-1.3-1.8-1.8l.6-.9c2 .8 3.2 1.9 3.2 3.2Z" />
  </SvgIcon>
)

LocationIcon.defaultProps = {
  sxProps: null,
}
